import api from "!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../node_modules/css-loader/index.js!./bootstrap.css";

var options = {"attributes":{"rel":"preload","as":"style"}};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/bootstrap.css
// module id = 964
// module chunks = 113